const CONFIG = {
    BASE_URL: "https://analytics-api.heartbreathmind.org/v1/",
    // BASE_URL: "http://127.0.0.1:8000/v1/",

    // Function to create URL with endpoint
    createUrl: function(endpoint = "") {
        return `${this.BASE_URL}${endpoint}`;
    },
    HEADERS: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    }
};

export default CONFIG;
